import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { classNames } from 'primereact/utils';
import { Dialog } from 'primereact/dialog';
import { useApiHook } from '../Helper/ApiHook/apiHook';
import { useStateValue } from "../GlobalState/StateProvider";
import { useNavigate } from 'react-router-dom';
import './Login.css'

const Login = ({ userType }) => {
    const d = new Date();
    const navigate = useNavigate();
    const [showMessage, setShowMessage] = useState(false);
    const [formData, setFormData] = useState({});
    const [loginNow, setLoginNow] = useState(false);
    const [displayNewLogin, setDisplayNewLogin] = useState(false);
    const [{ user }, dispatch] = useStateValue();

    const defaultValues = {
        email: '',
        password: ''
    }

    
    const { control, getValues, formState: { errors }, handleSubmit, reset } = useForm({ defaultValues });

    const url =  'api/auth/Authenticate';

    const params = {
        Email: getValues().email,
        Password: getValues().password
        
    };

    const [{ status, loading, data, error }, callAPI] = useApiHook(url,
        {
            verb: "post",
            useCache: false,
            params: params
        });

   
    useEffect(() => {

        if (status === 'fetched') {
           

            var user = { user_id: data.user_id, userName: data.email, email: data.email, token: data.token, created: data.created };
            localStorage.setItem('CoderFromMars_User', JSON.stringify(user));
            dispatch({
                type: 'ADD_USER',
                item: user
            })

            navigate("/Dashboard");
          
           
            
            
        }
        else if (status === 'error')
        {
            console.log(data);
            setLoginNow(false);
            setShowMessage(true);
            reset();
        }
    }, [status])
   
    useEffect(() => {

        if (loginNow === true) {
            callAPI();
        }
       
    }, [loginNow])
   

    const onSubmit = (data) => {
        
        if (data.email != '' && data.password != '') {
            setFormData(data);
            setLoginNow(true);
        }
        else {
           
        }

        
        
    };

    const getFormErrorMessage = (name) => {
        return errors[name] && <small className="p-error">{errors[name].message}</small>
    };

    const dialogFooter = <div className="p-d-flex p-jc-center"><Button label="OK" className="p-button-text" autoFocus onClick={() => setShowMessage(false)} /></div>;

      

    const renderFooter = (name) => {
        return (
            <div>
                <Button label="Cancel" icon="pi pi-times" onClick={() => setDisplayNewLogin(false)} className="p-button-text" />
                <Button label="Create Now" icon="pi pi-check" onClick={() => setDisplayNewLogin(false)} autoFocus />
            </div>
        );
    }
    return (
        <div className="login">

            <Dialog visible={showMessage} onHide={() => setShowMessage(false)} position="top" footer={dialogFooter} showHeader={false} breakpoints={{ '960px': '80vw' }} style={{ width: '30vw' }}>
                <div className="d-flex flex-column">
                    <div className="text-center">
                    <i className="pi pi-times" style={{ fontSize: '5rem', color: 'var(--red-500)' }}></i>
                    <h5>Login Error!</h5>
                    <p style={{ lineHeight: 1.5, textIndent: '1rem' }}>
                        Not authorized / Incorrect login info
                        </p>
                    </div>
                </div>
            </Dialog>

            <div className="">
                <div className="card" >
                    {/*<div className="d-flex justify-content-center">*/}
                        
                    {/*    <h2 className="text-2xl font-bold leading-7 text-[#56b893] sm:truncate sm:text-3xl sm:tracking-tight">*/}
                    {/*        Login*/}
                    {/*    </h2>*/}
                    {/*</div>*/}
                    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">

                        <div className="p-field" style={{ marginTop:'15px' }}>
                            <span className="p-float-label p-input-icon-right">
                                {/*<i className="pi pi-envelope" />*/}
                                <Controller name="email" control={control}
                                    rules={{ required: 'Email is required.', pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: 'Invalid email address. E.g. example@email.com' } }}
                                    render={({ field, fieldState }) => (
                                        <InputText id={field.name} {...field} className={classNames({ 'p-invalid': fieldState.invalid })} />
                                    )} />
                                <label htmlFor="email" className={classNames({ 'p-error': !!errors.email })}>Email*</label>
                            </span>
                            {getFormErrorMessage('email')}
                        </div>
                        <div className="p-field" style={{ marginTop: '25px' }}>
                            <span className="p-float-label">
                                <Controller name="password" control={control} rules={{ required: 'Password is required.' }} render={({ field, fieldState }) => (
                                    <Password id={field.name} {...field} feedback={false} toggleMask className={classNames({ 'p-invalid': fieldState.invalid })} />
                                )} />
                                <label htmlFor="password" className={classNames({ 'p-error': errors.password })}>Password*</label>
                            </span>
                            {getFormErrorMessage('password')}
                        </div>
                        

                        <div className="mt-2">
                 
                        <Button type="submit" loading={loading} label={loading === true ? 'Authenticating...' : 'Login Now'}  className="p-mt-2" disabled={loading === true ? true : false} />
                        </div>
                    </form>

                  
                    <div className="d-flex justify-content-center" style={{ fontSize: '12px', marginTop: '25px' }}>
                        <p>  &copy; {d.getFullYear()}  CoderFromMars - All Rights Reserved. </p>
                    </div>

                </div>
                
                

            </div>

          
            {/*<div className="p-d-flex p-jc-center" style={{ marginTop: '20px' }}>*/}
            {/*    <Button label="Forget email/password" className="p-button-outlined p-button-help  p-button-rounded p-button-lg" onClick={handleForgetPassword} />*/}
            {/*</div>*/}
        </div>
    );
}
export default Login